export const getScrollHeight = ({ hasAges, roomIndex, rooms = [] } = {}) =>
  rooms.reduce(
    (previous, current, index) =>
      index < roomIndex || (index === roomIndex && index === rooms.length - 1 && hasAges)
        ? previous + current
        : previous,
    0,
  );
